export enum LanguageFlag {
  PT = "/images/flags/br.png", // Portuguese (Brazil)
  EN = "/images/flags/us.png", // English (USA)
  UK = "/images/flags/uk.png", // English-Britsh (USA)
  DE = "/images/flags/de.png", // German
  SP = "/images/flags/es.png", // Spanish (Spain)
  FR = "/images/flags/fr.png", // French
  IT = "/images/flags/it.png", // Italian
  RU = "/images/flags/ru.jpeg", // Russian
  GK = "/images/flags/gk.jpg", // Greek
  JP = "/images/flags/jp.png" // Japanese
}

export interface User {
  id: string;
  fullName: string;
  email: string;
  phone: string | null;
  avatarUrl: string | null;
  website?: string;
  social?: {
    instagram?: string | null;
    instagram1?: string | null;
    facebook?: string | null;
    youtube?: string | null;
  };
  service: {
    title: string;
    description: string;
    category: string;
    tags: string[];
    priceRange: string | null;
  };
  location: {
    city: string;
    region: string | null;
    regionFull?: string | null;
    online: boolean;
  };
  availability: {
    type: string;
    details: string | null;
  };
  languages: string[];
  isSupporter: boolean;
  isFeatured: boolean;
}
